import { render, staticRenderFns } from "./ConsumptionDataExchangePromos.vue?vue&type=template&id=b31d475e&lang=pug&"
import script from "./ConsumptionDataExchangePromos.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionDataExchangePromos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports